export enum ApiStatus {
    loading = 1,
    success = 2,
    error = 3,
}
